(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
//Dependencies
global.$ = global.jQuery;
var tether = require('tether');
global.Tether = tether;

var popper = require('popper.js');
global.Popper = popper;

//Libs
require('bootstrap');
require('swiper');
require('imagesloaded');
require('fastclick');
require('scrollreveal');

/*Custom*/

var breakpoint = require('./exports/breakpoint.js');
global.Breakpoint = breakpoint;

var menu = require('./exports/menu.js');
global.Menu = menu;


}).call(this,require("km4Umf"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/fake_dd95ca95.js","/")